import state from './moduleAffiliateState.js'
import mutations from './moduleAffiliateMutations.js'
import actions from './moduleAffiliateAction.js'
import getters from './moduleAffiliateGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
